import React from 'react';
import PropTypes from 'prop-types';
import { LinkBar } from '../../../components/LinkBar/LinkBar';
import Watch from './views/Watch/Index';
import { connect } from 'react-redux';
import Error from './views/Error';
import CalendarPageComponent from './views/Calendar';
import Discover from './views/Discover';

const linkBarItems = [
  {
    label: 'Calendar',
    slug: 'calendar',
    url: '/events'
  },
  {
    label: 'Discover',
    slug: 'discover',
    url: '/events/video'
  }
];

const EventsPage = ({ status, view }) => {
  const setActiveItems = items =>
    items.map(item => {
      if (item.slug === view) {
        item.active = true; // eslint-disable-line no-param-reassign
      } else {
        item.active = false; // eslint-disable-line no-param-reassign
      }
      return item;
    });

  if (status === 404 || status === 500) {
    return <Error statusCode={status} />;
  }

  return (
    <>
      <LinkBar items={setActiveItems(linkBarItems)} />
      {view === 'video' && <Watch />}
      {view === 'discover' && <Discover />}
      {view === 'calendar' && <CalendarPageComponent />}
      {!view && <Error statusCode={404} />}
    </>
  );
};

function mapStateToProps(state = {}) {
  return {
    status: state.status.code,
    view: state.eventsPage?.view
  };
}

EventsPage.propTypes = {
  view: PropTypes.string.isRequired,
  status: PropTypes.number.isRequired
};

export default connect(mapStateToProps)(EventsPage);
